import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  hoverable?: boolean;
}

/**
 * Card component for containing content
 *
 * A flexible container with padding and shadow for grouping related content.
 * Can be made hoverable for interactive cards.
 */
export const Card: React.FC<CardProps> = ({ children, className, onClick, hoverable = false }) => {
  return (
    <div
      onClick={onClick}
      className={`
        rounded-lg bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700
        shadow-sm transition-shadow duration-200
        ${hoverable ? 'hover:shadow-md cursor-pointer' : ''}
        ${className || ''}
      `}
    >
      {children}
    </div>
  );
};

interface CardHeaderProps {
  children: React.ReactNode;
  className?: string;
}

export const CardHeader: React.FC<CardHeaderProps> = ({ children, className }) => (
  <div className={`px-6 py-4 border-b border-gray-200 dark:border-gray-700 ${className || ''}`}>{children}</div>
);

interface CardBodyProps {
  children: React.ReactNode;
  className?: string;
}

export const CardBody: React.FC<CardBodyProps> = ({ children, className }) => (
  <div className={`px-6 py-4 ${className || ''}`}>{children}</div>
);

interface CardFooterProps {
  children: React.ReactNode;
  className?: string;
}

export const CardFooter: React.FC<CardFooterProps> = ({ children, className }) => (
  <div className={`px-6 py-4 border-t border-gray-200 dark:border-gray-700 flex items-center gap-2 ${className || ''}`}>
    {children}
  </div>
);
